@if (scans() != null) {
  <div class="buttons">
    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="new-tab-outlined"
      onyxTooltip="labels.openInNewTab"
      (click)="showFiles()"
    ></onyx-icon-button>

    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="download-outlined"
      onyxTooltip="labels.download"
      (click)="downloadFiles()"
    ></onyx-icon-button>
  </div>
}
